export default __webpack_public_path__ + "static/Entenda0136-423881fc19196c02ed4ff4fb82e266be.jpg";